import React, { useState } from 'react';
import AppModal from '.';
import { Space, Upload, message, Result, Button } from 'antd';
import { InboxOutlined, CheckCircleFilled } from '@ant-design/icons';
import handleUpload from '@/utils/upload.utils';

const { Dragger } = Upload;

function ImportModal({ open, setOpen, onImport, loading }) {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleCancel = () => {
    setFileList([]);
    setIsSuccess(false);
    setOpen(false);
  };

  const handleFileChange = (info) => {
    setFileList(info.fileList);
  };

  const handleOk = async () => {
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj || fileList[0];
      setUploading(true);

      try {
        const uploadPromise = new Promise((resolve, reject) => {
          const options = {
            file,
            onSuccess: (response) => {
              resolve(response.url || response.location);
            },
            onError: (error) => {
              reject(error);
            },
            onProgress: (progress) => {},
          };

          handleUpload(
            options,
            (fileUrl) => {
              resolve(fileUrl);
            },
            'file',
            '/topic/create/excel' // test
          );
        });

        const uploadedFileUrl = await uploadPromise;

        if (onImport) {
          await onImport(uploadedFileUrl);
        }

        setIsSuccess(true);
      } catch (error) {
        // console.error('Import failed:', error);
        const { data } = error;
        message.error(data.errorMessage || 'Failed to import file');
      } finally {
        setUploading(false);
      }
    }
  };

  const handleTryAgain = () => {
    setIsSuccess(false);
    setFileList([]);
  };

  return (
    <AppModal
      open={open}
      onCancel={handleCancel}
      onOk={isSuccess ? handleCancel : handleOk}
      okText={isSuccess ? 'Done' : 'Import'}
      okButtonProps={{
        disabled: !isSuccess && fileList.length === 0,
        loading: loading || uploading,
      }}
      cancelButtonProps={{
        style: { display: isSuccess ? 'none' : 'inline-block' },
        disabled: loading || uploading,
      }}
      title="Import Excel"
      closable={false}
    >
      {isSuccess ? (
        <Result
          icon={<CheckCircleFilled style={{ color: '#52c41a' }} />}
          title="Import Successful!"
          subTitle="Your Excel file has been successfully imported and processed."
          extra={[
            <Button key="try-again" onClick={handleTryAgain}>
              Import Another
            </Button>,
          ]}
          className="p-0"
        />
      ) : (
        <Space direction="vertical" className="w-full">
          <Dragger
            accept=".xls,.xlsx"
            beforeUpload={() => false} // Prevent auto upload
            fileList={fileList}
            onChange={handleFileChange}
            maxCount={1}
            disabled={uploading || loading}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag to this area to import</p>
            <p className="ant-upload-hint">Only accept .xls, .xlsx files</p>
          </Dragger>
        </Space>
      )}
    </AppModal>
  );
}

export default ImportModal;
